import { Map as ImmMap, fromJS } from 'immutable';
import { RECEIVE_BRAND_INFO } from './constants';

export const initialState = new ImmMap({
	brandInfo: new ImmMap(),
});

const categoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case RECEIVE_BRAND_INFO:
			return state.set('brandInfo', fromJS(action.brandInfo));
		default:
			return state;
	}
};

export default categoriesReducer;
